
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/examples.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-examples-demo-basic","docs-x-markdown-examples-demo-streaming","docs-x-markdown-examples-demo-components","docs-x-markdown-examples-demo-supersets","docs-x-markdown-examples-demo-plugin","docs-x-markdown-examples-demo-xss"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-markdown/examples.en-US.md?type=demo')
};